export default [
	{
		key: 'timestamp',
		label: 'Date/Time',
		sorteable: true
	},
	{
		key: 'action',
		label: 'Action',
		sorteable: false
	},
	{
		key: 'changedByUserName',
		label: 'Changed By',
		sorteable: true
	}
];
